import { combineReducers } from 'redux'
import {
    SET_LOADING,
    SET_USER_INFO,
    SET_IS_LOGIN,
    // SET_EVT_OPTION,
    // SET_PLN_OPTION,
    // SET_ALL_OPTION
} from './action'

const initialUser = {
    userInfo: { user_idx: 0 },
    isLogin: false,
}

const user = (state = initialUser, action) => {
    if (action.type === SET_USER_INFO) return Object.assign({}, state, { userInfo: action.userInfo })
    if (action.type === SET_IS_LOGIN) return Object.assign({}, state, { isLogin: action.isLogin })
    return state
}

const initDataLoading = {
    isLoading: false,
}

const common = (state = initDataLoading, action) => {
    if (action.type === SET_LOADING) return Object.assign({}, state, { isLoading: action.isLoading })
    return state
}

export default combineReducers({ user, common })
